import { Chip } from '@material-tailwind/react'
import { useTheme } from '@table-library/react-table-library/theme'
import { useTranslation } from 'react-i18next'
import { FiFolder } from 'react-icons/fi'
import { Link, useSearchParams } from 'react-router-dom'

// table
import { StatusChip } from '@/components/status-chip'
import { attachment, edit } from '@/router/utils'
import {
  EditButton
} from '@/shared/components/action-buttons'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { HasAccess } from '@permify/react-role'
import { usePagination } from '@table-library/react-table-library/pagination'
import {
  Body,
  Cell,
  Header,
  HeaderCell,
  HeaderRow,
  Row,
  Table
} from '@table-library/react-table-library/table'

import { useSelector } from 'react-redux'
import { useGetAssetsQuery } from '@/store/services'
import { Pagination } from '@/shared/components/pagination'
export const AssetTable = () => {
  // Preferir obtener los datos con los hooks RTK en lugar useLoaderData(react-router). ver: https://reactrouter.com/en/main/guides/data-libs#invalidating-data-in-mutations
  const { data: { assets = [], meta = {} } = {} } = useGetAssetsQuery(location.search, { skip: !location.search })

  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const nodes = { nodes: assets }

  const onPaginationChange = (_, state) => {
    const page = state.page + 1
    const perPage = searchParams.get('per_page')

    searchParams.set('page', page)
    searchParams.set('per_page', perPage)
    setSearchParams(searchParams)
  }

  const pagination = usePagination(
    nodes,
    {
      state: {
        page: searchParams.get('page') - 1 || 0,
        size: searchParams.get('per_page') || 10
      },
      onChange: onPaginationChange
    },
    {
      isServer: true
    }
  )

  const chipOptions = {
    active: 'green',
    inactive: 'red'
  }

  const theme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    `,
    BaseCell: `
      &:nth-of-type(8) {
        right: 0px;
      }
    `
  })

  const controlAccesoTheme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: repeat(4, 1fr);
    `
  })

  const { user } = useSelector((state) => state)

  const isControlAcceso =
    (user?.current?.roles || [])[0].name === 'Control de acceso'
  return (

    <div className='relative flex flex-col justify-between gap-4 h-full'>
      <Table
        data={nodes}
        pagination={pagination}
        layout={{ custom: true, fixedHeader: true }}
        theme={isControlAcceso ? controlAccesoTheme : theme}
        className='h-max'
      >
        {(tableList) => (
          <>
            <Header>
              <HeaderRow>
                <HeaderCell resize>Tipo de activo</HeaderCell>
                <HeaderCell resize>patente</HeaderCell>
                <HeaderCell hide={isControlAcceso} resize>
                  Contrato
                </HeaderCell>
                <HeaderCell hide={isControlAcceso} resize>
                  Rut contratista
                </HeaderCell>
                <HeaderCell resize>Estado</HeaderCell>
                <HeaderCell resize>Acreditado</HeaderCell>
                <HeaderCell hide={isControlAcceso} resize>
                  NC
                </HeaderCell>
                <HeaderCell hide={isControlAcceso} pinRight resize>
                  Acciones
                </HeaderCell>
              </HeaderRow>
            </Header>

            <Body>
              {tableList.map(
                ({ vehicleInfo, contract, company, ...item }) => (
                  <Row key={item.id} item={item}>
                    <Cell>{vehicleInfo.type}</Cell>
                    <Cell>{vehicleInfo.patent}</Cell>
                    <Cell hide={isControlAcceso}>
                      {contract.id} - {contract.name}<br />
                      {contract.company.name}
                    </Cell>
                    <Cell hide={isControlAcceso}>
                      {company.document_number}
                    </Cell>
                    <Cell>
                      <StatusChip value={item.status} options={chipOptions} />
                    </Cell>
                    <Cell>
                      <Chip
                        variant='ghost'
                        color={item.accredited === 'active' ? 'green' : 'red'}
                        size='sm'
                        className='capitalize text-center h-fit w-fit'
                        value={
                          item.accredited === 'active'
                            ? t('common.true')
                            : t('common.false')
                        }
                      />
                    </Cell>
                    <Cell hide={isControlAcceso}>{item.nonconformities}</Cell>
                    <Cell pinRight hide={isControlAcceso}>
                      <div className='flex gap-3'>
                        <HasAccess permissions={['asset#edit']}>
                          <Link to={edit('assets', item.id)}>
                            <EditButton />
                          </Link>
                        </HasAccess>
                        <HasAccess permissions={['asset#attachments']}>
                          <LinkWithQuery to={attachment('assets', item.id)}>
                            <FiFolder
                              className='cursor-pointer'
                              size='1rem'
                            />
                          </LinkWithQuery>
                        </HasAccess>
                      </div>
                    </Cell>
                  </Row>
                )
              )}
            </Body>
          </>
        )}
      </Table>
      <Pagination
        onPageChange={({ selected }) => pagination.fns.onSetPage(selected)}
        page={pagination.state.page}
        totalPage={meta?.pagination?.total_pages}
      />
    </div>
  )
}
